<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="stage_name"
                                       label="Stage name"
                                       validation="required"
                                       size="8"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.stage_name" />

                        <FormInputText fieldName="symbol"
                                       label="Symbol"
                                       size="2"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.symbol" />

                        <FormRadioButton fieldName="has_external_link"
                                         label="Has external link"
                                         validation="required"
                                         size="2"
                                         :isFormDisabled="isFormDisabled"
                                         :data="select?.yes_no"
                                         v-model:field="crud.has_external_link" />

                        <FormInputText v-if="crud.has_external_link"
                                       fieldName="external_route_name"
                                       label="External route name"
                                       size="12"
                                       validation="required|max:255"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.external_route_name" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'stages', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormRadioButton from '@crud/FormRadioButton.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import CustomButton from '@crud/CustomButton.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const options = ['yes_no'];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select)
    if (props.formProps.addMode) {
        crud.value.has_external_link = false;
    }
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
